import React from 'react';
import { Icon, Spin, Modal, Tooltip } from 'antd';
import { useUpdateDomain } from '../../../../mutation/domain-warmup';

export default function MoveToWarmupButton({ domain }) {
  const { mutate, isLoading } = useUpdateDomain();
  const onClick = () => {
    Modal.confirm({
      title: 'Do you want to move this domain to warmed up?',
      onOk: () => {
        mutate({
          domain: domain.name,
          data: {
            isWarmedUp: true,
          },
        });
      },
    });
  };
  return (
    <Spin spinning={isLoading}>
      <Tooltip title="Move to Post Warmed Up">
        <Icon
          style={{ fontSize: 22 }}
          theme="twoTone"
          twoToneColor="#fb8b23"
          type="fire"
          onClick={onClick}
        />
      </Tooltip>
    </Spin>
  );
}
